module.exports = __webpack_public_path__ + "static/assets/d2b41f6e34ede05f87b6ce9c3b3d74fc.jpg";